import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FeaturesModule } from '@cigna/features';
import { OmniSharedUiModule } from '@cigna/omni/shared';
import { OmniChatStateModule } from '@cigna/omni/chat-state';
import { OmniCommChannelFeatureModule } from '@cigna/omni/comm-channel-feature';
import { OmniConversationSummaryListModule } from '@cigna/omni/conversation-summary-list';
import { OmniMessagingModule } from '@cigna/omni/messaging';
import { UiIconModule } from '@cigna/ui/icon';
import { DialogComponent } from './dialog/dialog.component';
import { OmniShellHeaderComponent } from './header/header.component';
import { HistoryComponent } from './history/history.component';
import { HomeComponent } from './home/home.component';
import { ShellComponent } from './shell/shell.component';
import { OmniShellChatHeaderComponent } from './chat-header/chat-header.component';
import { ReactiveComponentModule } from '@ngrx/component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    FeaturesModule,
    OmniChatStateModule,
    OmniCommChannelFeatureModule,
    OmniMessagingModule,
    OmniConversationSummaryListModule,
    OmniSharedUiModule,
    UiIconModule,
    ReactiveComponentModule,
  ],
  declarations: [
    ShellComponent,
    DialogComponent,
    HomeComponent,
    HistoryComponent,
    OmniShellHeaderComponent,
    OmniShellChatHeaderComponent,
  ],
  exports: [ShellComponent],
})
export class OmniChatModule {}
